import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";

// Constantes
const datosIniciales = {
  accessToken: null,
  idTipoConcurso: null,
  idSistema: null,
  idAspirante: null,
  idConcurso: null,
  idConvocatoria: null,
  idEstadoExamen: null,
  idEstatusProceso: null,
  idMotivoDescarte: null,
  idTipoCargoPuesto: null,
  idCargoPuesto: null,
  fhConfirma: null,
  usuarioConfirma: null,
  idTipoConfirma: null,
  estatus: null,
  usuario: null,
  informacion: {
    isSaved: false,
    isError: false,
    mensaje: null,
  },
  //Obtener Postulaciones
  msg: "",
  listPostula: [],
  mensajeExito: "",
  mensajeError: "",

  //Valida estus proceso
  resultadoProceso: 0,

  //bandera btn postulacion
  btnbandera: 0,
  sistemaBand: [],

  //Fecha seguimiento postulacion
  fechaSeguimiento: {},

  //Obtener Validacion btn Postularme
  resultadoFinal: {},

  //Loading
  loading: false,
};

// types

const SET_POSTULACION = "[POSTULACIONES] SET_POSTULACION";
const FECHA_SEGUIMIENTO_POSTULACION =
  "[POSTULACIONES] FECHA_SEGUIMIENTO_POSTULACION";
const GET_POSTULACION_ASPIRANTE = "[POSTULACIONES] GET_POSTULACION_ASPIRANTE";
const GET_POSTULACION_ERROR = "[POSTULACIONES] GET_POSTULACION_ERROR";
const SET_HISTORIAL_ASPIRANTE = "[POSTULACIONES] SET_HISTORIAL_ASPIRANTE";
const GET_HISTORIAL_ERROR = "[POSTULACIONES] GET_HISTORIAL_ERROR";
const GET_MENSAJE = "[POSTULACIONES] GET_MENSAJE";
const CLEAN_STATE_POSTULACIONES = "[POSTULACIONES] CLEAN_STATE_POSTULACIONES";
const SET_ACTIVA_MENSAJE_POSTULACIONES =
  "[POSTULACIONES] SET_ACTIVA_MENSAJE_POSTULACIONES";
const CLEAN_ACTIVA_MENSAJE_POSTULACIONES =
  "[POSTULACIONES] CLEAN_ACTIVA_MENSAJE_POSTULACIONES";
const SET_ACTIVA_MENSAJE_ERROR_POSTULACIONES =
  "[POSTULACIONES] SET_ACTIVA_MENSAJE_POSTULACIONES";
const CLEAN_ACTIVA_MENSAJE_ERROR_POSTULACIONES =
  "[POSTULACIONES] CLEAN_ACTIVA_MENSAJE_ERROR_POSTULACIONES";

const RESULTADO_PROCESO = "[POSTULACIONES] RESULTADO_PROCESO";
const RESULTADO_FINAL = "[POSTULACIONES] RESULTADO_FINAL";
const CLEAN_RESULTADO_PROCESO = "[POSTULACIONES] CLEAN_RESULTADO_PROCESO";

const BOTON_BANDERA = "[POSTULACIONES] BOTON_BANDERA";
const CLEAN_BOTON_BANDERA = "[POSTULACIONES] CLEAN_BOTON_BANDERA";

const SISTEM_BANDERA = "[POSTULACIONES] SISTEM_BANDERA";
const LIMPIA_SISTEMA_BANDERA = "[POSTULACIONES] SISTEMA_BANDERA";
const LOADING_TABLE = "[POSTULACIONES] LOADING_TABLE";

//------------- REDUCER -----------------------------------------------------
export default function postulacionReducer(state = datosIniciales, action) {
  switch (action.type) {
    case SET_POSTULACION:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        idTipoConcurso: action.payload.idTipoConcurso,
        idSistema: action.payload.idSistema,
        idAspirante: action.payload.idAspirante,
        idConcurso: action.payload.idConcurso,
        idConvocatoria: action.payload.idConvocatoria,
        idEstadoExamen: action.payload.idEstadoExamen,
        idEstatusProceso: action.payload.idEstatusProceso,
        idMotivoDescarte: action.payload.idMotivoDescarte,
        idTipoCargoPuesto: action.payload.idTipoCargoPuesto,
        idCargoPuesto: action.payload.idCargoPuesto,
        fhConfirma: action.payload.fhConfirma,
        usuarioConfirma: action.payload.usuarioConfirma,
        idTipoConfirma: action.payload.idTipoConfirma,
        estatus: action.payload.estatus,
        usuario: action.payload.usuario,
      };
    case FECHA_SEGUIMIENTO_POSTULACION:
      return {
        ...state,
        fechaSeguimiento: { ...action.payload },
      };
    case GET_MENSAJE:
      return {
        ...state,
        informacion: {
          isSaved: action.payload.isSaved,
          isError: action.payload.isError,
          mensaje: action.payload.message,
        },
      };
    case GET_POSTULACION_ASPIRANTE:
      return {
        ...state,
        listPostula: [...action.payload],
      };
    case GET_POSTULACION_ERROR:
      return {
        ...state,
        msg: "Ocurrio algo inesperado al consultar la postulación",
      };
    case SET_HISTORIAL_ASPIRANTE:
      return {
        ...state,
        idAspirante: action.payload.idAspirante,
        idConcurso: action.payload.idConcurso,
        idConvocatoria: action.payload.idConvocatoria,
        idTipoCargoPuesto: action.payload.idTipoCargoPuesto,
        idCargoPuesto: action.payload.idCargoPuesto,
      };
    case GET_HISTORIAL_ERROR:
      return {
        ...state,
        msg: "Ocurrio algo inesperado al insertar el historial del aspirante",
      };
    case CLEAN_STATE_POSTULACIONES:
      return datosIniciales;
    case SET_ACTIVA_MENSAJE_POSTULACIONES:
      return {
        ...state,
        mensajeExito: action.payload,
      };
    case CLEAN_ACTIVA_MENSAJE_POSTULACIONES:
      return {
        ...state,
        mensajeExito: "",
      };
    case SET_ACTIVA_MENSAJE_ERROR_POSTULACIONES:
      return {
        ...state,
        mensajeError: action.payload,
      };
    case CLEAN_ACTIVA_MENSAJE_ERROR_POSTULACIONES:
      return {
        ...state,
        mensajeError: "",
      };
    case RESULTADO_PROCESO:
      return {
        ...state,
        resultadoProceso: action.payload,
      };
    case RESULTADO_FINAL:
      return {
        ...state,
        resultadoFinal: { ...action.payload },
      };
    case CLEAN_RESULTADO_PROCESO:
      return {
        ...state,
        resultadoProceso: 0,
      };

    case BOTON_BANDERA:
      return {
        ...state,
        btnbandera: action.payload,
      };
    case CLEAN_BOTON_BANDERA:
      return {
        ...state,
        btnbandera: 0,
      };
    case SISTEM_BANDERA:
      return {
        ...state,
        sistemaBand: [...action.payload],
      };
    case LOADING_TABLE:
      return {
        ...state,
        loading: action.payload,
      };

    case LIMPIA_SISTEMA_BANDERA:
      // return {
      //   ...state,
      //   sistemaBand: 0,
      // };
      return datosIniciales;
    default:
      return state;
  }
}

//------------- ACTIONS --------------------------------------

export const getMessage = (isError, isSaved, message) => ({
  type: GET_MENSAJE,
  payload: {
    isError,
    message,
    isSaved,
  },
});

export const fechaSeguimientoPostula = (state) => ({
  type: FECHA_SEGUIMIENTO_POSTULACION,
  payload: state,
});

export const sistemBandera = (state) => ({
  type: SISTEM_BANDERA,
  payload: state,
});

export const resultadoProceso = (state) => ({
  type: RESULTADO_PROCESO,
  payload: state,
});

export const btnBandera = (state) => ({
  type: BOTON_BANDERA,
  payload: state,
});

export const getPostulacion = (state) => ({
  type: GET_POSTULACION_ASPIRANTE,
  payload: state,
});

export const geterrorPostulacion = (state) => ({
  type: GET_POSTULACION_ERROR,
  payload: state,
});

export const setHistorialAspirante = (state) => ({
  type: SET_HISTORIAL_ASPIRANTE,
  payload: state,
});

export const errorHistorial = (state) => ({
  type: GET_HISTORIAL_ERROR,
  payload: state,
});

export const cleanStatePostulaciones = () => ({
  type: CLEAN_STATE_POSTULACIONES,
});

export const setMensajeExito = (state) => ({
  type: SET_ACTIVA_MENSAJE_POSTULACIONES,
  payload: state,
});

export const cleanMensajeExito = () => ({
  type: CLEAN_ACTIVA_MENSAJE_POSTULACIONES,
});

export const setMensajeError = (state) => ({
  type: SET_ACTIVA_MENSAJE_ERROR_POSTULACIONES,
  payload: state,
});

export const cleanMensajeError = () => ({
  type: CLEAN_ACTIVA_MENSAJE_ERROR_POSTULACIONES,
});

export const cleanResultadoProceso = () => ({
  type: CLEAN_RESULTADO_PROCESO,
});

export const cleanbtnBandera = () => ({
  type: CLEAN_BOTON_BANDERA,
});

export const limpiaSistemaBandera = () => ({
  type: LIMPIA_SISTEMA_BANDERA,
});

export const setPostulacion = (data, dataDos) => async (dispatch, getState) => {
  const { accessToken } = getState().usuarioLogin;
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlRegistroPostulacion,
      data,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (response.data.mensajeId === 1) {
      dispatch(getMessage(false, true, response.data.mensaje));
      dispatch({
        type: SET_POSTULACION,
        payload: JSON.parse(JSON.stringify(response.data)),
      });
      dispatch({
        type: RESULTADO_PROCESO,
        payload: response.data.idAspirante, //Se reutiliza para retornar idEstusProceso
      });
      if (response.data.idAspirante === 1) {
        dispatch(insertHistorial(dataDos));
      }
    } else {
      dispatch(getMessage(true, false, response.data.mensaje));
    }
  } catch (error) {
    console.log(error);
    console.log("No se insertaron los datos");
  }
};

export const obtenerPostulacion = () => async (dispatch, getState) => {
  const { accessToken, idAspirante } = getState().usuarioLogin;
  dispatch({
    type: LOADING_TABLE,
    payload: true,
  });
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerPostulacion}`,
      { idAspirante },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    dispatch({
      type: GET_POSTULACION_ASPIRANTE,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_POSTULACION_ERROR,
      payload: error.response.data,
    });
  }
  dispatch({
    type: LOADING_TABLE,
    payload: false,
  });
};

export const insertHistorial = (data) => async (dispatch, getState) => {
  const { accessToken } = getState().usuarioLogin;
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlInsertaHistorial,
      data,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    dispatch({
      type: SET_HISTORIAL_ASPIRANTE,
      payload: JSON.parse(JSON.stringify(response.data)),
    });
  } catch (error) {
    dispatch({
      type: GET_HISTORIAL_ERROR,
      payload: error.response.data,
    });
  }
};

export const setUpdatePostulacion = (data) => async (dispatch, getState) => {
  const { accessToken } = getState().usuarioLogin;
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlUpdatePostulacion,
      data,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (response.data.idMensaje === 1) {
      dispatch(setMensajeExito(response.data.mensaje));
    } else {
      dispatch(setMensajeError(response.data.mensaje));
    }
  } catch (error) {
    console.log(error);
    console.log("No se actualizaron los datos");
    dispatch(setMensajeError("No se actualizaron los datos"));
  }
};

export const ObtenerfechaSeguimiento = () => async (dispatch, getState) => {
  const { accessToken } = getState().usuarioLogin;
  let data = {};
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlFechaSeguimiento,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    dispatch({
      type: FECHA_SEGUIMIENTO_POSTULACION,
      payload: response.data,
    });
  } catch (error) {
    console.log(error);
    console.log("No se obtuvo la fecha");
  }
};

export const getValidacionPostula = (data) => async (dispatch, getState) => {
  const { accessToken } = getState().usuarioLogin;
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlObtenerValidacion,
      data,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    dispatch({
      type: RESULTADO_FINAL,
      payload: response.data,
    });
  } catch (error) {
    // console.log(error);
    // console.log("No se pudo obtener la validacion");
    // // dispatch(setMensajeError("No se evaluo al aspirante"));
  }
};
